export default "/images/independent-ie.svg?25c527a5ffb4049049e52633f7d83a91";